import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ElastiqueService } from 'src/app/service/elastique.service';

@Component({
  selector: 'app-elastique',
  templateUrl: './elastique.component.html',
  styleUrls: ['./elastique.component.scss'],
})
export class ElastiqueComponent implements OnInit {

  btn1IsChecked = false;
  btn2IsChecked = false;

  constructor(
    public modalCtrl: ModalController,
    private elastiqueservice : ElastiqueService,
  ) { }

  ngOnInit() {
    this.getInfoForCheckBtnFromBD();
  }
  getInfoForCheckBtnFromBD(){
    const idPatient = localStorage.getItem("idPatient");
    this.elastiqueservice.getByid(idPatient).subscribe((res : any)=>{
      if (res.length == 0) {
        console.log("rien");
      }else{
        this.elastiquedata = res[0];
        console.log('data de la base'+this.elastiquedata.elastique1);
        if (res[0].elastique1) {
          this.btn1IsChecked = true;
        }
        if (res[0].elastique2) {
          this.btn2IsChecked = true;
        }
      }
    })
  }
  Checkbtn1(){
    this.btn1IsChecked=!this.btn1IsChecked;
    if (this.btn1IsChecked == true) {
      this.elastiquedata.elastique1 = 1;
    }
    if(this.btn1IsChecked == false){
      this.elastiquedata.elastique1 = 0;
    }
  }
  Checkbtn2(){
    this.btn2IsChecked=!this.btn2IsChecked;
    if (this.btn2IsChecked == true) {
      this.elastiquedata.elastique2 = 1;
    }
    if(this.btn2IsChecked == false){
      this.elastiquedata.elastique2 = 0;
    }
  }
  elastiquedata = {
    idpatient : Number(localStorage.getItem('idPatient')),
    iddiag : Number(localStorage.getItem('IdDiagnostic')),
    elastique1 : 0,
    elastique2 : 0
  }
  saveElastique(){
    const idPatient = localStorage.getItem("idPatient");
    this.elastiqueservice.getByid(idPatient).subscribe((res : any)=>{
      
      if (res.length == 0) {
        this.elastiqueservice.addNewElastique(this.elastiquedata).subscribe((res:any)=>{
          console.log("ress add : ", res);
          this.closeModal();
        })
        
      }else{
        this.elastiqueservice.updateElastique(res[0].id,this.elastiquedata).subscribe((res:any)=>{
          console.log("res updated" , res);
          this.closeModal();
        })
      }
    })
  }
  closeModal() {
    this.modalCtrl.dismiss();
  }
}
